import { ValidationResult, ValidationError, RequiredFieldCheck } from '@/views/helpers/validation-result';
import ValidationMessages from '@/views/helpers/validation-messages';
import ValidationCodes from '@/views/helpers/validation-codes';
import DisabilityRate from '@/views/validations/disability-rate';

export default {
  validate (reportOfSickness, originalReportOfSickness) {
    let validationResult = new ValidationResult();

    validationResult.push(DisabilityRate.validateDisabilityRateFormat(reportOfSickness.disabilityRate));
    validationResult.push(DisabilityRate.validateDisabilityRateMinimum(reportOfSickness.disabilityRate));
    validationResult.push(DisabilityRate.validateDisabilityRateMaximum(reportOfSickness.disabilityRate));
    validationResult.push(this.validateChanges(reportOfSickness, originalReportOfSickness));

    return validationResult;
  },

  requiredFields (reportOfSickness) {
    let validationResult = new ValidationResult();

    validationResult.push(RequiredFieldCheck('firstOfAbsence', reportOfSickness.firstOfAbsence));
    validationResult.push(RequiredFieldCheck('disabilityRate', reportOfSickness.disabilityRate));
    validationResult.push(RequiredFieldCheck('safetyNet', reportOfSickness.safetyNet));
    validationResult.push(RequiredFieldCheck('accident', reportOfSickness.accident));

    if (reportOfSickness.accident === true) {
      validationResult.push(RequiredFieldCheck('thirdPartyLiability', reportOfSickness.thirdPartyLiability));
    }

    return validationResult;
  },

  validateChanges (reportOfSickness, originalReportOfSickness) {
    if (reportOfSickness.getSearchString() === originalReportOfSickness.getSearchString()) {
      return new ValidationError({
        message: ValidationMessages.ReportOfSickness.NO_VALUE_WAS_CHANGED,
        attribute: 'reportOfSickness',
        code: ValidationCodes.NO_CHANGES
      });
    }
  }
};
